import React from 'react';
import { Link } from 'react-router-dom';
// eslint-disable-next-line
import { Code2, Github, Twitter, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer-premium">
            <div className="container">
                <div className="footer-top-grid">
                    <div className="footer-brand-side">
                        <Link to="/" className="footer-logo">
                            <div className="icon-sq">
                                <img src="/logo.png" alt="Aadhar Infotech Logo" style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '10px' }} />
                                {/* <Code2 className="text-white" size={24} /> */}
                            </div>
                            <span className="footer-brand-text">
                                AADHAR <span className="highlight">INFOTECH</span>
                            </span>
                        </Link>
                        <p className="footer-tagline">
                            Leading the way in digital innovation. We provide cutting-edge software solutions to help your business thrive in the modern world.
                        </p>
                        <div className="footer-social-row">
                            <Link to="/" className="social-link-circle"><Github size={20} /></Link>
                            <Link to="/" className="social-link-circle"><Twitter size={20} /></Link>
                            <Link to="/" className="social-link-circle"><Linkedin size={20} /></Link>
                        </div>
                    </div>

                    <div className="footer-nav-col">
                        <h4 className="footer-head">Company</h4>
                        <ul className="footer-ul">
                            <li><Link to="/">Home Dashboard</Link></li>
                            <li><Link to="/about">Our Story</Link></li>
                            <li><Link to="/services">Tech Solutions</Link></li>
                            <li><Link to="/portfolio">Recent Work</Link></li>
                            <li><Link to="/contact">Get in Touch</Link></li>
                        </ul>
                    </div>

                    <div className="footer-nav-col">
                        <h4 className="footer-head">Expertise</h4>
                        <ul className="footer-ul">
                            <li><Link to="/services">Web Development</Link></li>
                            <li><Link to="/services">Mobile Applications</Link></li>
                            <li><Link to="/services">Cloud Integration</Link></li>
                            <li><Link to="/services">UI/UX Design</Link></li>
                            <li><Link to="/services">AI & Analytics</Link></li>
                        </ul>
                    </div>

                    <div className="footer-contact-col">
                        <h4 className="footer-head">Office</h4>
                        <div className="contact-info-block">
                            <div className="ct-item">
                                <Mail size={18} className="ct-icon" />
                                <span>info.aadharinfotech7@gmail.com</span>
                            </div>
                            <div className="ct-item">
                                <Phone size={18} className="ct-icon" />
                                <span>+91 8218629011</span>
                            </div>
                            <div className="ct-item">
                                <MapPin size={18} className="ct-icon" />
                                <span>Lucknow, Uttar Pradesh, India</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-base">
                    <p className="copyright-text">&copy; {new Date().getFullYear()} Aadhar Infotech. Built with Excellence.</p>
                    <div className="base-links">
                        <Link to="/privacy">Privacy Policy</Link>
                        <Link to="/terms">Terms of Service</Link>
                        <Link to="/cookies">Cookies</Link>
                    </div>
                </div>
            </div>

        </footer>
    );
};

export default Footer;
